// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3H1AW","row":"styles_row__2niVI","noUnderline":"styles_noUnderline__3kiCg","infoText":"styles_infoText__1xnrN","Notification":"styles_Notification__1BbFq"};